module.exports = {
    wiretransfer: 'Error occured, please try again later or contact support',
}